import React from 'react';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import {useInvoiceOrdersGridContext} from '../InvoiceOrdersGridContext';
import download from '../../../../common/assets/icons/download.svg';
import styles from './ButtonDownload.module.scss';

const ButtonDownload = ({}) => {
  const {saveListToExcelFile} = useInvoiceOrdersGridContext();

  return (
    <ButtonAction
      variant={'icon'}
      icon={download}
      onClick={saveListToExcelFile}
      customClassnames={{
        container: styles.buttonContainer,
        icon: styles.buttonIcon,
      }}
    />
  );
};

export default ButtonDownload;
